<template>
  <v-app id="searchBkmt1">
    <v-main>
     <v-container fluid>
       <v-row no-gutters>
        <v-card class="px-2">
            <v-text-field
            v-model="search"
              label="Search"
              single-line
              hide-details
             >
            </v-text-field>
        
            <v-data-table 
            :items="items" 
            :items-per-page="200" 
            :footer-props="{'items-per-page-options': [50, 100, 200, 500, 1000, 2000, 5000]}"
            :headers="headers"
            :search="search"        
            >
            <template v-slot:item="props">
              <tr>
               <td>{{props.item.bkmt_transactionTimestamp}} </td>
               <td>{{props.item.bkmt_descriptionLines1}} <br> 
                   {{props.item.bkmt_transactionId}} <br>
                   <b class="green--text"> {{props.item.bkmt_type}} </b><a v-if="props.item.huov_code > ''" @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"> {{props.item.huov_code}} </a>
                 </td>
               <td v-html="props.item.bkmt_descriptionLinesRest"></td>
               <td align="right">{{props.item.bkmt_amount}} </td>
               <!-- <td><v-btn class="primary ma-2" x-small @click="updBkmt(props.item.bkmt_encrid)">Update</v-btn></td> -->
               <td><v-btn v-if="props.item.bkmt_gevonden == false" class="primary ma-2" x-small @click="manualBkmt(props.item.bkmt_encrid)">Manual</v-btn></td>
              </tr>
            </template>
            </v-data-table>
        </v-card>
        </v-row>
     </v-container>
     <updBkmt ref="updBkmt"></updBkmt>
     <manualBkmt ref="manualBkmt"></manualBkmt>
    </v-main>
    <navBar :title="'Ares - Finance'" :home="true" type="finance"/>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import updBkmt from "@/views/task/fin/abn/bkmt/updBkmt.vue";
import manualBkmt from "@/views/task/fin/abn/bkmt/manualBkmt.vue";
 export default {
  components: {
    navBar,
    updBkmt,
    manualBkmt
  },
  data() {
    return {
      items: [],
      search: '',
      headers: [
        {text: 'Date/Time', value: 'bkmt_transactionTimestamp'},
        {text: 'Type / Transaction Id', value: 'bkmt_descriptionLines1'},
        {text: 'Description', value: 'bkmt_descriptionLinesRest'},
        {text: 'Amount', align: 'end', value: 'bkmt_amount'},
         {text: 'Manual', value: 'bkmt_gevonden'}
      ]
    }  
  },
  mounted() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/task/fin/abn/bkmt/searchBkmt1.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "searchBkmt1"
          },
          searchBkmt1: {
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.searchBkmt1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    showHuov(huov_encrid) {
      console.log(huov_encrid);
      let route = this.$router.resolve({ path: '/huov/onHuov/' + huov_encrid});
      window.open(route.href, '_blank');                                  
    },
    updBkmt(bkmt_encrid) {
       this.$refs.updBkmt.open(bkmt_encrid);
    },
    manualBkmt(bkmt_encrid) {
       this.$refs.manualBkmt.open(bkmt_encrid);
    },
  }
};

</script> 
